import {fsa, fsaError, fsaPayload, fsaPayloadByKeys} from '../helpers'

import {ShowroomData} from '../../typedefs/showrooms'

export enum ShowroomDetailActionName {
  success = 'showrooms/get showroom location request success',
  failure = 'showrooms/get showroom location request failure',
  pending = 'showrooms/get showroom location request pending',
  init = 'showrooms/get showroom location request',
}

interface GetShowroomLocationInitAction {
  type: ShowroomDetailActionName.init
}

interface GetShowroomLocationPendingAction {
  type: ShowroomDetailActionName.pending
}

interface GetShowroomLocationFailureAction {
  type: ShowroomDetailActionName.failure
  payload: string
}

interface GetShowroomLocationSuccessAction {
  type: ShowroomDetailActionName.success
  payload: ShowroomData
}

type GetShowroomLocationSuccessFn = (payload: ShowroomData) => GetShowroomLocationSuccessAction

type GetShowroomLocationInitFn = (showroomSlug: string) => GetShowroomLocationInitAction

type GetShowroomLocationFailureFn = (error: string) => GetShowroomLocationFailureAction

type GetShowroomLocationPendingFn = () => GetShowroomLocationPendingAction

export type ShowroomDetailAction =
  | GetShowroomLocationSuccessAction
  | GetShowroomLocationFailureAction
  | GetShowroomLocationPendingAction
  | GetShowroomLocationInitAction

// TODO: can get rid of the constant once we replace all files that reference the action with TS and use the enum
export const GET_SHOWROOM_LOCATION = ShowroomDetailActionName.init
export const getShowroomLocation: GetShowroomLocationInitFn = fsaPayloadByKeys(
  GET_SHOWROOM_LOCATION,
  ['showroomSlug'],
)

// TODO: can get rid of the constant once we replace all files that reference the action with TS and use the enum
export const GET_SHOWROOM_LOCATION_FAILURE = ShowroomDetailActionName.failure
export const getShowroomLocationFailure: GetShowroomLocationFailureFn = fsaError(
  GET_SHOWROOM_LOCATION_FAILURE,
)

// TODO: can get rid of the constant once we replace all files that reference the action with TS and use the enum
export const GET_SHOWROOM_LOCATION_PENDING = ShowroomDetailActionName.pending
export const getShowroomLocationPending: GetShowroomLocationPendingFn = fsa(
  GET_SHOWROOM_LOCATION_PENDING,
)

// TODO: can get rid of the constant once we replace all files that reference the action with TS and use the enum
export const GET_SHOWROOM_LOCATION_SUCCESS = ShowroomDetailActionName.success
export const getShowroomLocationSuccess: GetShowroomLocationSuccessFn = fsaPayload(
  GET_SHOWROOM_LOCATION_SUCCESS,
)
